import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Modal, ModalHeader, ModalBody, ButtonGroup, Button } from 'reactstrap';
import classnames from 'classnames';

import { store } from '../../store';
import { setCurrentOnboardingStep, 
         setOnboardingKycVerificationStatus, 
         setOnboardingKycDetails,
         setCurrentAccountOnboardingStage,
         setOnboardingFlowType,
         setOnboardingPan,
         setOnboardingDataForAddPan,
         clearOnboarding } from "../../actions";
import { userService } from '../../user/services/user';
import { OnboardingStages, OnboardingForms, KycVerificationStatus } from "../../constants";
import { OnboardingHelpers } from '../helpers';

import { OroLoader } from '../../core';
import KycCheck from './onboarding/KycCheck';
import KycCompleted from './onboarding/KycCompleted';
import KycIncomplete from './onboarding/BseKycIncomplete';
import UploadDocs from './onboarding/UploadDocs';
import KycRemaining from './onboarding/KycRemaining';
import { setCleverTapEvent } from '../../core/helpers/analytics';

class Onboarding extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: props.isOpen === undefined ? true : props.isOpen,
      isLoadingOnboardingData: false
    }

    this.getOnboardingForm = this.getOnboardingForm.bind(this);
    this.moveNext = this.moveNext.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    //Set onboardingStep --> used for setting the current form that the user needs to see. 
    //Set onboardingStage --> used to indicate the onboarding status from the backend.
    let stage = this.props.fromUserStates ? store.getState().onboarding.currentStep : OnboardingHelpers.getOnboardingStep(store.getState().user.panOnboardingStage)
    if (this.props.kycVerified) {
      this.moveNext(this.props.stepName,{ 
      kycVerificationStatus: this.props.kycVerificationStatus, kycData: this.props.kycData})
      return;
    }
    if(this.props.type === 'onboarding') {
      store.dispatch( setOnboardingFlowType('onboarding') );
      store.dispatch( setCurrentAccountOnboardingStage(store.getState().user.panOnboardingStage) );
      store.dispatch( setCurrentOnboardingStep(stage));
      store.dispatch( setOnboardingPan( store.getState().user && store.getState().user.validPans ? store.getState().user.validPans.default : '') );
      this.getOnboardingForm();
    } else if(this.props.type === 'add-account') {
      if(store.getState().onboarding && store.getState().onboarding.onboardingFlowType === 'add-account') {
        this.getOnboardingForm();
      } else {
        store.dispatch( clearOnboarding() );
        store.dispatch( setOnboardingFlowType('add-account') );
        store.dispatch( setCurrentOnboardingStep( OnboardingForms.KYC_CHECK ) );
        store.dispatch( setCurrentAccountOnboardingStage(OnboardingStages.PAN_NOT_VERIFIED) );
        store.dispatch( setOnboardingPan('') );
        this.getOnboardingForm();
      }
    } else {
      store.dispatch( clearOnboarding() );  
      store.dispatch( setOnboardingFlowType('complete-setup') );
      if(this.props.pan) {
        this.setState({
          isLoadingOnboardingData: true
        });

        var pan = this.props.pan;
        store.dispatch( setOnboardingPan(pan) );
        userService.getPanOnboardingStage(pan)
              .then(response => {
                store.dispatch(setCurrentAccountOnboardingStage(response.stage));
                store.dispatch(setCurrentOnboardingStep( OnboardingHelpers.getOnboardingStep(response.stage) ));
                store.dispatch(setOnboardingDataForAddPan({pan: pan}));
                this.getOnboardingForm();

                this.setState({
                  isLoadingOnboardingData: false
                });
              })
              .catch(error => {
                console.log('userService.getPanOnboardingStage');
                console.log(error);
              });
      } else {
        store.dispatch(setCurrentOnboardingStep( OnboardingForms.KYC_CHECK )); 
        store.dispatch( setOnboardingPan('') );
        this.getOnboardingForm();               
      }
    }
  }

  getOnboardingForm() {
    switch(store.getState().onboarding.currentStep) {
      case OnboardingForms.KYC_CHECK:
        if(store.getState().onboarding.kycDetails && store.getState().onboarding.kycDetails.kycData && store.getState().onboarding.kycDetails.kycData.pan) {
          store.dispatch(setCurrentOnboardingStep( OnboardingForms.KYC_INCOMPLETE ));
          this.getOnboardingForm();
        } else {
          this.setState({
            onboardingForm: <KycCheck onComplete={this.moveNext} 
                                      stepName={OnboardingForms.KYC_CHECK} 
                                      type={this.props.type}
                                      isMfuFlow={this.props.isMfuFlow}
                                      isBseFlow={this.props.isBseFlow} />
          });
        }
        break;
      case OnboardingForms.KYC_READY:
         this.setState({
          onboardingForm: <KycCompleted onComplete={this.moveNext} stepName={OnboardingForms.KYC_READY} />
        });
        break;
      case OnboardingForms.UPDATE_DOCS:
        this.setState({
          onboardingForm: <UploadDocs onComplete={this.moveNext} 
                                      stepName={OnboardingForms.UPDATE_DOCS} 
                                      pan={store.getState().onboarding.pan || store.getState().onboarding.addPan.pan}
                                      email={store.getState().user.userDetails.info.email} 
                                      showHeader={true}
                                      />
        });
        break;
      case OnboardingForms.KYC_INCOMPLETE:
        if(store.getState().onboarding.kycDetails && store.getState().onboarding.kycDetails.kycData && !store.getState().onboarding.pan) {
          store.dispatch( setOnboardingPan(store.getState().onboarding.kycDetails.kycData.pan) );
        }
        let pan = store.getState().onboarding.pan ? store.getState().onboarding.pan : store.getState().onboarding.addPan ? store.getState().onboarding.addPan.pan : ""
        this.setState({
          onboardingForm: <KycIncomplete onComplete={this.moveNext}
                                         stepName={OnboardingForms.KYC_INCOMPLETE} 
                                         pan={pan}
                                         email={store.getState().user.userDetails.info.email}
                                         dob={store.getState().onboarding.addPan ? store.getState().onboarding.addPan.dob : ''}
                                         redirectTo={this.props.redirectTo}
                                         instantFromOutside= {this.props.instantFromOutside}
                                         redirectLocation={this.props.redirectLocation}
                                         />
        });
        break;
      case OnboardingForms.SETUP_COMPLETED:
        this.setState({
          onboardingForm: (
              <p className="mb-0 pl-8 pr-8 pt-0 pb-8">
                Your documents are being processed.Please reach out to connect@orowealth.com or +91-7587305393 for any further questions.
              </p>
            )
        })
      default:
        return <p>You're done so far.</p>
    }
  }

  moveNext(stepName, data) {
    switch(stepName) {
      case OnboardingForms.KYC_CHECK:
        store.dispatch(setOnboardingKycVerificationStatus(stepName));
        if(data) {
          store.dispatch(setOnboardingKycDetails(data));

          if (data.kycData && data.kycData.can) {
            store.dispatch(setOnboardingKycVerificationStatus("KYC_READY"));
            this.closeModal();
          }
        } 
          
        if (this.props.isBseFlow) {
          if (data.othersPan) {
              return;
          }
          store.dispatch(setCurrentOnboardingStep(
            store.getState().onboarding.kycDetails.kycVerificationStatus === KycVerificationStatus.KYC_COMPLETE ? this.moveNext('BSE_SETUP', data) : OnboardingForms.KYC_INCOMPLETE));
        } else {
          store.dispatch(setCurrentOnboardingStep(
            store.getState().onboarding.kycDetails.kycVerificationStatus === KycVerificationStatus.KYC_COMPLETE ? OnboardingForms.KYC_READY : OnboardingForms.KYC_INCOMPLETE));
        }
        break;

      case OnboardingForms.KYC_READY:
        store.dispatch(setCurrentOnboardingStep(OnboardingForms.UPDATE_DOCS));
        break;

      case OnboardingForms.UPDATE_DOCS:
        this.props.onOnboardingCompleted();
        this.closeModal();
        break;
      case OnboardingForms.KYC_INCOMPLETE:
        this.props.onOnboardingCompleted();
        this.closeModal();
        break;

      case 'BSE_SETUP':
            if (data && data.kycData) {
              this.setState({
                onboardingForm: <KycRemaining 
                  onComplete={this.moveNext} 
                  kycData={data.kycData}
                  fromUserState={this.props.kycVerified}
                  stepName={OnboardingForms.KYC_READY} 
                  goToBank = {this.props.onOnboardingCompleted}  
                  checkFor = {"BSE_SETUP"}
                />
              });
              return;
            }
            return this.setState({
              onboardingForm: <KycCompleted 
                                onComplete={this.moveNext} 
                                stepName={OnboardingForms.KYC_READY} 
                                goToBank = {this.props.onOnboardingCompleted}  
                                checkFor = {"BSE_SETUP"}
                              />
            });
      default:
        break;
    }
    this.getOnboardingForm();
  }

  closeModal() {
    if (this.props.fromUserStates) {
      this.props.toggleOnboarding();
    }
    this.props.onOnboardingCompleted();
  }

  goToBank() {
    setCleverTapEvent("Onboarding KYC Complete");
    this.props.onOnboardingCompleted('KYC_COMPLETE');
  }

  render() {
    if(this.state.isLoadingOnboardingData) {
      return (
        <Modal isOpen={this.props.isOpen === undefined ? this.state.isOpen : this.props.isOpen}  
               toggle={this.closeModal} 
               className={classnames('modal-lg onboarding-modal ' + this.props.className)} backdrop="static">
          <ModalHeader toggle={this.closeModal}>
          </ModalHeader>

          <ModalBody>
            <div className="p-8 text-center">
              <OroLoader />
            </div>
          </ModalBody>
        </Modal>
      );
    }

    return (
      <Modal isOpen={this.props.isOpen === undefined ? this.state.isOpen : this.props.isOpen}
               toggle={this.closeModal} 
               className={classnames('modal-lg onboarding-modal w-100 ' + this.props.className)}
               backdrop={"static"} keyboard= {true}>
          <ModalHeader toggle={this.closeModal}>
          </ModalHeader>

          <ModalBody>
            {this.state.onboardingForm}
          </ModalBody>
      </Modal>
    );
  }
}

export default Onboarding; 